export const stats = [
  {
    title: "پایداری و دسترس‌پذیری در سطح سازمانی",
    cap: "تضمین دسترسی‌پذیری ۹۹.۹٪ با توزیع جغرافیایی و تکرار داده‌ها",
  },
  {
    title: "نسخه‌نگاری (ٰVersioning)",
    cap: "امنیت نگهداری داده با ذخیره سازی توزیع شده نسخه های مختلف داده",
  },
  {
    title: "امنیت داده‌ها با ویژگی Object Lock",
    cap: "جلوگیری از حذف یا بازنویسی برای محافظت داده‌های حیاتی با قابلیت WORM",
  },
  {
    title: "قابلیت انتخاب سطح دسترسی",
    cap: "امکان انتخاب باکت‌های عمومی یا خصوصی و تنظیم سطح دسترسی به داده‌ها بر اساس نیاز",
  },
];

export const serviceFeatures = [
  {
    title: "مقیاس‌پذیری بدون محدودیت",
    desc: "پشتیبانی از رشد داده‌ها در مقیاس‌های بالا، بدون نیاز به تغییر زیرساخت یا وقفه در سرویس",
    logo: "centralized.svg",
    imgAlt: "مقیاس‌پذیری بدون محدودیت",
    imgTitle: "مقیاس‌پذیری بدون محدودیت",
  },
  {
    title: "معماری قابل انعطاف برای هر‌گونه پروژه",
    desc: "طراحی‌شده برای مدیریت بارهای متغیر و قابل گسترش هم‌زمان با توسعه پروژه",
    logo: "enterprise.svg",
    imgAlt: "معماری قابل انعطاف برای هر‌گونه پروژه",
    imgTitle: "معماری قابل انعطاف برای هر‌گونه پروژه",
  },
  {
    title: "دسترسی سریع و یکپارچه به داده‌ها",
    desc: "ساختار شی‌محور و متادیتای قابل‌شخصی‌سازی برای بازیابی سریع و دقیق اطلاعات",
    logo: "monitor.svg",
    imgAlt: "دسترسی سریع و یکپارچه به داده‌ها",
    imgTitle: "دسترسی سریع و یکپارچه به داده‌ها",
  },
  {
    title: "کاهش پیچیدگی در پشتیبان‌گیری و آرشیو",
    desc: "گزینه‌ای ایده‌آل برای نگهداری نسخه‌های پشتیبان، آرشیو بلندمدت و داده‌های چندرسانه‌ای",
    logo: "configuration.svg",
    imgAlt: "کاهش پیچیدگی در پشتیبان‌گیری و آرشیو",
    imgTitle: "کاهش پیچیدگی در پشتیبان‌گیری و آرشیو",
  },
];

export const objectStorage = [
  {
    title: "مهاجرت آسان و کم‌هزینه",
    desc: "با پشتیبانی از پروتکل استاندارد S3، مهاجرت داده از سایر سرویس‌ها بدون نیاز به تغییر کد یا ابزار خاص، به‌صورت تدریجی و On Demand نیز امکان‌پذیر است.",
    logo: "resource.svg",
    imgAlt: "مهاجرت آسان و کم‌هزینه",
    imgTitle: "مهاجرت آسان و کم‌هزینه",
  },
  {
    title: "سازگاری با ابزارهای رایج",
    desc: "ابزارهای محبوبی مانند AWS SDK به‌راحتی قابل استفاده‌اند و مدیریت داده‌ها را برای تیم‌های فنی ساده می‌کنند.",
    logo: "architect.svg",
    imgAlt: "سازگاری با ابزارهای رایج",
    imgTitle: "سازگاری با ابزارهای رایج",
  },
  {
    title: "مدیریت منعطف با ساختار باکت‌ها",
    desc: "ساختار باکت‌ها در آبجکت استوریج، تفکیک داده و کنترل دسترسی را ساده و متناسب با نیازهای پروژه‌ فراهم می‌کند.",
    logo: "uptime.svg",
    imgAlt: "مدیریت منعطف با ساختار باکت‌ها",
    imgTitle: "مدیریت منعطف با ساختار باکت‌ها",
  },
  {
    title: "پشتیبانی از مهاجرت در مقیاس بالا",
    desc: "با موازی‌سازی خودکار و بهره‌گیری از شبکه بهینه، مهاجرت حتی در شرایط تأخیر بالا بین سرور و آبجکت استوریج با عملکرد پایدار انجام می‌شود.",
    logo: "panel.svg",
    imgAlt: "پشتیبانی از مهاجرت در مقیاس بالا",
    imgTitle: "پشتیبانی از مهاجرت در مقیاس بالا",
  },
];

export const locations = [
  {
    img: "iranServer.svg",
    name: "آبجکت استوریج آبالون؛ فضای ابری توزیع‌شده در سراسر کشور",
    cap: "سرویس آبجکت استوریج آبالون با معماری مولتی‌ریجن (Multi-Region) طراحی شده و امکان ذخیره‌سازی داده‌ها در نزدیک‌ترین ریجن (دیتاسنتر) را فراهم می‌سازد تا تأخیر دسترسی به حداقل برسد. این سرویس همچنین در مدل‌های اختصاصی (Dedicated) و خصوصی (Private Access) قابل ارائه است: در مدل Dedicated، زیرساخت ذخیره‌سازی، به‌طور کامل برای یک سازمان رزرو می‌شود؛ در مدل Private، ارتباط بین سازمان شما با سرویس از طریق لینک‌های اختصاصی و غیر اشتراکی (نورونتا) برقرار شده و عملکردی سریع‌تر و ایزوله‌ را برای سازمان‌های دارای الزامات خاص فراهم می‌کند.",
    alt: "آبجکت استوریج آبالون؛ فضای ابری توزیع‌شده در سراسر کشور",
    title: "آبجکت استوریج آبالون؛ فضای ابری توزیع‌شده در سراسر کشور",
    class: "iranImg",
  },
];

export const uses = [
  {
    img: "disaster.svg",
    name: "بایگانی محتوای صوتی و تصویری",
    desc: "ذخیره‌سازی بلندمدت و مقرون‌به‌صرفه محتوای دوربین‌های نظارتی یا تجهیزات صوتی و رسانه‌ای",
    alt: "بایگانی محتوای صوتی و تصویری",
    title: "بایگانی محتوای صوتی و تصویری",
  },

  {
    img: "backup.svg",
    name: "امنیت در برابر باج‌افزار",
    desc: "راهکاری امن برای بکاپ‌گیری با قابلیت بازیابی سریع در سناریوهای حمله باج‌افزارها",
    alt: "امنیت در برابر باج‌افزار",
    title: "امنیت در برابر باج‌افزار",
  },
  {
    img: "test.svg",
    name: "دیتاست‌های یادگیری ماشین",
    desc: "فضایی قابل اطمینان برای ذخیره و آرشیو دیتاست‌های حجیم مورد نیاز برای آموزش مدل‌های ML/AI",
    alt: "دیتاست‌های یادگیری ماشین",
    title: "دیتاست‌های یادگیری ماشین",
  },
  {
    img: "startup.svg",
    name: "ذخیره‌سازی لاگ‌ها و مانیتورینگ",
    desc: "نگهداری مداوم و طولانی‌مدت لاگ‌های سیستمی و داده‌های مانیتورینگ جهت تحلیل‌های آینده",
    alt: "ذخیره‌سازی لاگ‌ها و مانیتورینگ",
    title: "ذخیره‌سازی لاگ‌ها و مانیتورینگ",
  },
  {
    img: "service.svg",
    name: "آرشیو Cold",
    desc: "انتقال خودکار داده‌ها بین استوریج‌های hot و cold بر اساس میزان خوانده شدن",
    alt: "آرشیو Cold",
    title: "آرشیو Cold",
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد.",
    logo: "VPS-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری",
    imgTitle: "دیتاسنتر ابری",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },

  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "ManagedService-Service.svg",
    route: "/dedicated-server",
    imgAlt: "سرور اختصاصی",
    imgTitle: "سرور اختصاصی",
  },
  {
    title: "PAM ابری آبالون",
    desc: "با استفاده از راهکار PAM ابری آبالون، بدون نیاز به زیرساخت داخلی، دسترسی کاربران به سیستم‌عامل‌ها و نرم‌افزارهای سازمانی را به‌صورت ایمن و متمرکز مدیریت و تمام فعالیت‌ها را ثبت و کنترل کنید.",
    logo: "DNS.svg",
    route: "/pam",
    imgAlt: "PAM ابری آبالون",
    imgTitle: "PAM ابری آبالون",
  },
];

export const solotionTabItems = [
  {
    title: "همانندسازی درون منطقه‌ای (Replication)",
    img: "cdn/startup.svg",
    imgAlt: "همانندسازی درون منطقه‌ای (Replication) آبالون",
    imgTitle: "همانندسازی درون منطقه‌ای (Replication) آبالون",
    img_deactive: "cdn/startup.svg",
    section_title: "همانندسازی درون منطقه‌ای (Replication)",
    caption:
      "در این مدل، محتوای هر باکت دلخواه که در آبجکت استوریج اصلی، واقع در یک Region (مثلاً تهران) ذخیره شده، به‌صورت خودکار در دیتاسنتر Region دیگری (مثلاً تبریز) همانندسازی می‌شود. این روش، راهکاری مقرون‌به‌صرفه برای افزایش اطمینان از حفظ داده‌ها و بازیابی آن‌ها پس از وقوع اختلالات احتمالی است.",
    contentImg: "security/firewall-image.svg",
    contentImgAlt: "همانندسازی درون منطقه‌ای (Replication) آبالون",
    contentImgTitle: "همانندسازی درون منطقه‌ای (Replication) آبالون",
    link: "",
    linkTitle: "",
    alt: "همانندسازی درون منطقه‌ای (Replication)",
    contentItem: [
      {
        name: "بدون پیچیدگی فنی",
      },
      {
        name: "آرشیو چند منطقه‌ای",
      },
      {
        name: "اطمینان از حفظ داده‌ها",
      },
      {
        name: "مقرون‌به‌صرفه و کارآمد",
      },
    ],
  },
  {
    title: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    img: "cdn/store.svg",
    imgAlt: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    imgTitle: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    img_deactive: "cdn/store.svg",
    section_title: "سرویس PAM ابری",
    caption:
      "در این مدل، آبجکت استوریج به‌صورت توزیع‌شده در دو یا چند دیتاسنتر در Region جغرافیایی متنوع (مانند شیراز و مشهد) مستقر است. دیتاسنترها از طریق لینک‌های پرسرعت، با تأخیر پایین (Low Latency) و پشتیبانی از High Availability، امکان دسترسی لحظه‌ای به داده‌ها حتی در صورت قطعی کامل یک منطقه را فراهم می‌کنند.",
    contentImg: "security/waf-banner.svg",
    contentImgAlt: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    contentImgTitle: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    link: "",
    linkTitle: "",
    alt: "ذخیره‌سازی چندمنطقه‌ای (Multi‑Region)",
    contentItem: [
      {
        name: "اطمینان از حفظ داده‌ها",
      },
      {
        name: "همانندسازی لحظه‌ای داده‌ها",
      },
      {
        name: "ارتباط پایدار در شرایط بحرانی",
      },
      {
        name: "دسترسی همیشگی به داده‌ها",
      },
    ],
  },
  {
    title: "استقرار در زیرساخت داخلی (On‑Premise)",
    img: "cdn/company.svg",
    imgAlt: "استقرار در زیرساخت داخلی (On‑Premise)",
    imgTitle: "استقرار در زیرساخت داخلی (On‑Premise)",
    img_deactive: "cdn/company.svg",
    section_title: "استقرار در زیرساخت داخلی (On‑Premise)",
    caption:
      "در این مدل، راهکار آبجکت استوریج آبالون به‌صورت کامل در زیرساخت اختصاصی سازمان (مانند دیتاسنتر داخلی یا سرورهای خصوصی) مستقر می‌شود و تمامی داده‌ها در محیط داخلی ذخیره می‌شود. این ساختار، مناسب نهادهایی است که به دلایل الزامات امنیتی، نیاز به نظارت مستقیم بر موقعیت فیزیکی داده و رعایت سیاست‌های امنیتی سازمان را دارند.",
    contentImg: "ddosProtection/ddos-image.svg",
    contentImgAlt: "استقرار در زیرساخت داخلی (On‑Premise)",
    contentImgTitle: "استقرار در زیرساخت داخلی (On‑Premise)",
    link: "",
    linkTitle: "",
    alt: "استقرار در زیرساخت داخلی (On‑Premise)",
    contentItem: [
      {
        name: "جداسازی از بسترهای عمومی و اشتراکی",
      },
      {
        name: "مطابق با الزامات امنیتی سازمان",
      },
      {
        name: "یکپارچگی با زیرساخت داخلی",
      },
      {
        name: "قابل توسعه به سرویس‌های ابری آبالون",
      },
    ],
  },
];

export const questions = [
  {
    title:
      "چرا آبجکت استوریج آبالون گزینه‌ای مقرون‌به‌صرفه برای ذخیره‌سازی داده‌های حجیم است؟",
    answer:
      "با حذف کامل هزینه‌های مربوط به خروج داده (Egress-Free) و استفاده از ساختار cold storage، صرفه‌جویی چشمگیری برای ذخیره‌سازی، بکاپ‌گیری و مهاجرت داده‌ها—به‌ویژه در سناریوهایی با نرخ خواندن پایین—امکان‌پذیر است.",
  },
  {
    title:
      "آیا امکان مهاجرت ساده از سرویس‌های دیگر به آبجکت استوریج آبالون وجود دارد؟",
    answer:
      "بله، با پشتیبانی کامل از استاندارد S3، مهاجرت از سایر سرویس‌ها بدون نیاز به بازنویسی کد یا ابزارهای خاص و به‌صورت تدریجی (حتی on-demand) قابل انجام است.",
  },
  {
    title: "چه ابزارهایی با آبجکت استوریج آبالون سازگار هستند؟",
    answer:
      "سرویس آبالون با ابزارهای رایجی مانند AWS SDK کاملاً سازگار است و استفاده از APIها را هنگام بهره‌گیری از راهکار آبجکت استوریج امکان‌پذیر می‌کند.",
  },
  {
    title: "آیا آبجکت استوریج آبالون از مدل آرشیو Cold و Hot پشتیبانی می‌کند؟",
    answer:
      "بله، فایل‌هایی با نیاز به دسترسی مداوم روی بخش Hot ذخیره می‌شوند تا بالاترین سرعت را داشته باشند و فایل‌هایی که مدت طولانی خوانده نمی‌شوند، به بخش Cold منتقل می‌شوند تا هزینه ذخیره‌سازی کاهش یابد.",
  },
  {
    title:
      "چه نوع سازمان‌هایی از آبجکت استوریج آبالون بیشترین بهره را می‌برند؟",
    answer:
      "سازمان‌هایی که نیاز به آرشیو داده، نگهداری بکاپ، بازیابی در برابر باج‌افزار، ذخیره‌سازی داده‌های آموزشی برای هوش مصنوعی، آرشیو ویدئو/صدا یا ثبت لاگ‌های حجیم دارند، بیشترین بهره را از این سرویس خواهند برد.",
  },
];
